import { cn } from "@newxsystems/shared";
import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { ResponsiveBlockGrid } from "../../../shared/components/ResponsiveBlockGrid/ResponsiveBlockGrid";
import { ResponsiveBlockGridItem } from "../../../shared/components/ResponsiveBlockGridItem/ResponsiveBlockGridItem";
import { TeamMemberCard } from "../TeamMemberCard/TeamMemberCard";
import type { ITeamMemberGridStandardProps } from "./TeamMemberGridStandard.props";

export const TeamMemberGridStandard = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITeamMemberGridStandardProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description);
  const hasIntro = hasCommonContent || Boolean(buttons?.length);

  return (
    <BlockContainer anchorId={anchorId} parentClass={parentClass} spacing={spacing}>
      {hasCommonContent ? (
        <BlockCommonContent
          alignment={alignment}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingLevel="h2"
        />
      ) : null}
      {buttons?.length ? (
        <BlockActions
          actions={buttons}
          alignment={alignment}
          className={cn(hasCommonContent && "mt-8")}
        />
      ) : null}
      <ResponsiveBlockGrid
        className={cn("gap-x-6 gap-y-10 md:gap-y-14", hasIntro && "mt-12 md:mt-16")}
        columnCount={columnCount}
      >
        {items.map((item, index) => (
          <ResponsiveBlockGridItem key={`${item.name}-${index}`}>
            <TeamMemberCard {...item} />
          </ResponsiveBlockGridItem>
        ))}
      </ResponsiveBlockGrid>
    </BlockContainer>
  );
};

TeamMemberGridStandard.displayName = "TeamMemberGrid::TeamMemberGridStandard";
